import axios, { AxiosError } from 'axios';
import type { FeatureFlagState, UpdateResult } from '../types';
import { resolveEndpoint } from '~/plugins/ApiEndpointRegistry';

const DEFAULT_STATE: FeatureFlagState = { unlock: false, flags: [] };

export const fetchFeatureFlags = async (): Promise<FeatureFlagState> => {
  try {
    const url = resolveEndpoint('featureFlags.list', '/api/feature/flags');
    const response = await axios.get(url);
    return response.data?.result ?? DEFAULT_STATE;
  } catch {
    return DEFAULT_STATE;
  }
};

export const updateFeatureFlag = async (
  payload: { key: string; enabled: boolean } | { unlock: boolean },
): Promise<UpdateResult<FeatureFlagState>> => {
  try {
    const url = resolveEndpoint('featureFlags.update', '/api/feature/flags');
    const response = await axios.put(url, payload);
    const data = response.data?.result ?? DEFAULT_STATE;
    return { success: true, data };
  } catch (error) {
    const axiosError = error as AxiosError<{ message?: string }>;
    const message =
      axiosError.response?.data?.message ||
      axiosError.message ||
      '設定の更新に失敗しました';
    return { success: false, error: message };
  }
};
